import React from "react";
import Text from "../../shared/text/Text";
import FlexBox from "../../shared/containers/FlexBox";
import HeroImage from "./HeroImage";

import styles from "./ClaimOwnershipModal.module.scss";

const InfoStepsBody = ({ body }) => {
  const { title, subtitle, infoConfig, imageUrl } = body ?? {};

  return (
    <div className={styles.infoBodySection}>
      <HeroImage imageUrl={imageUrl} />
      <Text uiData={title} className={styles.infoSectionTitle} />
      <Text uiData={subtitle} className={styles.infoSectionSubtitle} />

      <img
        src="https://b.zmtcdn.com/data/o2_assets/74f6e30132a35e82651008964139f6c91780996222.png"
        alt="Info"
        className={styles.infoSeparator}
      />

      {infoConfig && (
        <div className={styles.infoListContainer}>
          <Text uiData={infoConfig.title} className={styles.infoListTitle} />

          {(infoConfig.content ?? []).map((item, idx) => {
            const { stepConfig, title, subtitle } = item ?? {};
            const { value: stepValue, title: stepTitle } = stepConfig ?? {};
            return (
              <div key={idx} className={styles.infoListItem}>
                <div className={styles.infoListItemStepper}>
                  <span className={styles.infoListItemStepValue}>
                    {stepValue}
                  </span>
                  <Text
                    uiData={stepTitle}
                    className={styles.infoListItemStepTitle}
                  />
                </div>
                <div className="wd-100" gap={1}>
                  <Text uiData={title} className={styles.infoListItemTitle} />
                  <Text
                    uiData={subtitle}
                    className={styles.infoListItemSubtitle}
                  />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default InfoStepsBody;
